'use client'

import { ReactElement, useEffect, useState } from 'react'

import clsx from 'clsx'

import styles from './styles.module.scss'

export default function ToTop(): ReactElement {
    const [isShow, setIsShow] = useState(false)

    const toggleFloatingButton = (): void => {
        setIsShow(window.scrollY > 200)
    }

    useEffect(() => {
        document.addEventListener('scroll', toggleFloatingButton)
        return (): void =>
            document.removeEventListener('scroll', toggleFloatingButton)
    }, [])

    return (
        <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            aria-label={'На верх'}
            className={clsx(styles.button, {
                [styles.button__show]: isShow,
            })}
        />
    )
}
